import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import Slider from 'react-slick';
import css from './ListingPage.module.css';
import '../../styles/slick/slick-theme.css';
import '../../styles/slick/slick.css';

import categoryImg1 from '../../assets/category-img1.jpg';
import categoryImg2 from '../../assets/category-img2.jpg';
import categoryImg3 from '../../assets/category-img3.jpg';
import categoryImg4 from '../../assets/category-img4.jpg';
import { InlineTextButton, SecondaryButton } from '../../components';

/**
 * Category config
 * key -> value sent to search as pub_categoryLevel1
 * label -> button text
 * img -> image to display
 */
const CATEGORY_CONFIG = [
  { key: 'mahjong_sets', label: 'Mahjong Sets', img: categoryImg1 },
  { key: 'tiles', label: 'Tiles & Accessories', img: categoryImg2 },
  { key: 'mats', label: 'Tables & Mats', img: categoryImg3 },
  { key: 'accessories_and_gifts', label: 'Books & Guides', img: categoryImg4 },
  // Add more if you want:
  // { key: 'mahjong_travel_tiles', label: 'Travel Tiles', img: someImg },
  // { key: 'mahjong_racks_pushers', label: 'Racks & Pushers', img: someImg },
  // { key: 'accessories', label: 'Accessories', img: someImg },
];

function SimilarListingsSection(props) {
  const { sliderSettings: sliderSettingsProp, viewport } = props;
  const isMobileLayout = viewport && viewport.width > 0 && viewport.width < 768;

  const history = useHistory();
  const location = useLocation();

  // Clone slider settings so we can safely mutate for mobile
  const sliderSettings = useMemo(() => ({ ...(sliderSettingsProp || {}) }), [sliderSettingsProp]);

  if (isMobileLayout) {
    Object.assign(sliderSettings, { dots: false });
  }

  const goToCategory = categoryKey => {
    // Merge with existing query params (preserve address, bounds, etc.), but reset page.
    const params = new URLSearchParams(location.search);
    params.set('pub_categoryLevel1', categoryKey);
    params.delete('page'); // ensure we start from first page for a new category

    // If your Search page route is named differently, adjust the pathname below.
    // Common Sharetribe pattern is '/s'
    history.push({
      pathname: '/s',
      search: params.toString(),
    });
  };

  return (
    <div className={classNames(css.popularSessions, css.sectionPadding, css.justInSec)}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>For more style inspiration, explore our curated collections in the Lookbook</h2>
          <InlineTextButton>Visit the Lookbook</InlineTextButton>
        </div>

        <div className={css.sectionListings}>
          {/* If you want a slider later, wrap CATEGORY_CONFIG.map inside <Slider {...sliderSettings}> */}
          <Slider {...sliderSettings}>
            {CATEGORY_CONFIG.map(cat => (
              <div
                key={cat.key}
                className={css.categoryBlock}
                onClick={() => goToCategory(cat.key)}
              >
                <div className={css.categoryImg}>
                  <img src={cat.img} alt={cat.label} />
                </div>
                <div className={css.categoryInfo}>
                  <SecondaryButton>{cat.label}</SecondaryButton>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

SimilarListingsSection.defaultProps = {
  sliderSettings: {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    variableWidth: false,
    focusOnSelect: false,
    centerMode: false,
    responsive: [
      { breakpoint: 1500, settings: { slidesToShow: 4 } },
      { breakpoint: 1300, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 580, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  },
};

export default SimilarListingsSection;
